export const getSelectedWidgetStyle = (widgetIdentifiers, currentWidget, accentColor) => {
    const identifiers = Array.isArray(widgetIdentifiers) ? widgetIdentifiers : [widgetIdentifiers];
    if (identifiers.filter(Boolean).some((identifier) => identifier === currentWidget)) {
        const color = accentColor || '#3b82f6';
        return {
            border: `2px solid ${color}`,
            background: `linear-gradient(to bottom, ${color}14, #fff)`,
            boxShadow: `0 4px 12px ${color}20`,
            transform: 'translateY(-2px)',
        };
    }
    return {};
};
